import _plugin_vue_export_helper_default from "../../../../_virtual/_plugin-vue_export-helper.js";
import ResponseBodyRaw_vue_vue_type_script_setup_true_lang_default from "./ResponseBodyRaw.vue.script.js";
/* empty css                              */
//#region src/v2/blocks/response-block/components/ResponseBodyRaw.vue
var ResponseBodyRaw_default = /*#__PURE__*/ _plugin_vue_export_helper_default(ResponseBodyRaw_vue_vue_type_script_setup_true_lang_default, [["__scopeId", "data-v-6e055eb2"]]);
//#endregion
export { ResponseBodyRaw_default as default };

//# sourceMappingURL=ResponseBodyRaw.vue.js.map